import { useCallback } from 'react'
import { useSearchParams } from 'next/navigation'

/**
 * This hook is used to merge the current search params with a new set of params.
 */
export default function useCreateQueryString() {
  const searchParams = useSearchParams()

  // Get a new searchParams string by merging the current
  // searchParams with a provided key/value pair
  const createQueryString = useCallback(
    (params: Record<string, string | undefined>) => {
      const newSearchParams = new URLSearchParams(searchParams)

      // Update or delete each parameter
      Object.entries(params).forEach(([name, value]) => {
        if (value) {
          newSearchParams.set(name, value)
        } else {
          newSearchParams.delete(name)
        }
      })

      return newSearchParams.toString()
    },
    [searchParams]
  )

  return { searchParams, createQueryString }
}
